var _style, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoEsiea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 425.6 240.6",
    style: {
      enableBackground: "new 0 0 425.6 240.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#36A9E1;}\n\t.st1{fill:#FFFFFF;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 425.6,
    height: 240.6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M71.4,134.6c0-19,11.9-36.3,33.5-36.3c19.3,0,32.4,11.9,32.4,35v3.2H84.8c0.2,13.6,8,22.5,20.8,22.5 c11.5,0,17.5-6.1,18-13.2h13.2c-1.7,14-12.5,23.6-31.6,23.6C83.3,169.4,71.4,153.8,71.4,134.6z M123.5,126.5 c-1.1-12.3-8.7-17.7-18.4-17.7c-10,0-17.9,6.3-19.5,17.7H123.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M139.5,147.9h13.2c0.6,7.6,6.7,11.2,17.9,11.2c10.6,0,15.4-4.5,15.4-10.6c0-5.6-3.2-8.2-13.6-9.3l-9.3-0.9 c-14.5-1.5-21.6-7.3-21.6-18.8c0-14.1,11.2-21,26.8-21c16,0,27.7,6,28.7,20.1h-12.7c-0.9-7.1-6.5-9.9-16.2-9.9s-14.7,3.7-14.7,9.5 c0,5.4,3.3,7.6,11.9,8.6l9.3,0.9c16.7,1.7,23.8,7.3,23.8,20.3c0,13.8-11.2,21.6-28.7,21.6C151.6,169.4,139.9,161.6,139.5,147.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M205.6,70.6h14V85h-14V70.6z M206.1,100.4H219v67.3h-12.8V100.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M226.2,134.6c0-19,11.9-36.3,33.5-36.3c19.3,0,32.4,11.9,32.4,35v3.2h-52.5c0.2,13.6,8,22.5,20.8,22.5 c11.5,0,17.5-6.1,18-13.2h13.2c-1.7,14-12.5,23.6-31.6,23.6C238.1,169.4,226.2,153.8,226.2,134.6z M278.3,126.5 c-1.1-12.3-8.7-17.7-18.4-17.7c-10,0-17.9,6.3-19.5,17.7H278.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M295.4,148.6c0-18.6,16-21.2,32-21h14v-4.3c0-10-4.8-14.5-14.3-14.5c-6.7,0-14.3,2-15.8,10.8H298 c1.9-15.6,14.9-21.2,28.7-21.2c16,0,27.5,8.2,27.5,24.2v45.2h-11.9l-0.6-8.7h-0.6c-3.5,6-10.8,10.4-20.1,10.4 C305.8,169.4,295.4,162.7,295.4,148.6z M341.4,147.1v-9.5h-13.6c-9.1,0-18.8,0.2-18.8,10.8c0,8,5.6,10.6,12.5,10.6 C331.3,159,338.8,153.1,341.4,147.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoEsiea);
export default __webpack_public_path__ + "static/media/logo-esiea.c1b910d3b7c1f238f6f885a78fb1d796.svg";
export { ForwardRef as ReactComponent };